<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Media Conversion Logs</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body p-4">
  <div *ngIf="isLoader" class="text-center">
    <i class="fa fa-spinner fa-spin"></i> Loading...
  </div>

  <div *ngIf="!isLoader && conversionLogs.length === 0" class="text-center text-muted">
    <p>No conversion logs available.</p>
  </div>

  <div *ngIf="!isLoader && conversionLogs.length > 0" class="table-responsive data-grid sticky-header-table sticky-header-table-height-lg mt-4">
    <table mat-table [dataSource]="conversionLogs" class="table">
      <ng-container matColumnDef="studyFileId">
        <th mat-header-cell *matHeaderCellDef>Study File</th>
        <td mat-cell *matCellDef="let element" [attr.title]="element.message || null">{{ element.studyFileName }}</td>
      </ng-container>

    
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef>Created Date</th>
        <td mat-cell *matCellDef="let element">{{ element.createdDate | date:format }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>

